import { apiClient } from '~/shared/api/data-ingestion-api'
import { generateNewDocumentId } from './generate-new-document-id'
import { getExistingDocumentPageRanges } from './get-existing-document-page-ranges'
import { type DocumentPageRange } from './types'

export function splitDocumentPageRanges({
  documents,
  currentDocumentPageRanges,
  documentId,
  splitIndex,
}: {
  documents: apiClient.Document[]
  currentDocumentPageRanges: DocumentPageRange[]
  documentId: string
  splitIndex: number
}) {
  return currentDocumentPageRanges.flatMap((documentPageRange) => {
    if (documentPageRange.documentId === documentId) {
      const leftSide = {
        documentId: generateNewDocumentId(),
        pageRange: {
          startPage: documentPageRange.pageRange.startPage,
          endPage: splitIndex,
        },
        confidenceScore: 1,
      }
      const rightSide = {
        documentId: generateNewDocumentId(),
        pageRange: {
          startPage: splitIndex + 1,
          endPage: documentPageRange.pageRange.endPage,
        },
        confidenceScore: 1,
      }
      return getExistingDocumentPageRanges(documents, [leftSide, rightSide])
    }
    return [documentPageRange]
  })
}
